import { NextImage } from '@/components/NextImage'
import { useImage } from '@/hooks/images/useImage'
import { useTranslation } from '@/localization/useTranslation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'

import classNames from 'classnames'
import classes from './styles.module.scss'

interface ChannelHorizontalCardProps {
  item: any
  imageCut?: string
  handleCardClick?: (item: any) => void
  isPlaceholder?: boolean
  isLocked?: boolean
}

interface OverlayProps {
  item: any
  imageCut: string
}

export const ChannelHorizontalCard = (props: ChannelHorizontalCardProps) => {
  const {
    item,
    handleCardClick = () => null,
    imageCut = 'backdrop',
    isPlaceholder,
    isLocked = false,
  } = props
  const { t } = useTranslation()
  const title = t(item?.title)

  const { url: image } = useImage({
    images: item?.images,
    cut: imageCut,
    scale: '75',
  })

  return (
    <div className={classes.card} onClick={() => handleCardClick(item)}>
      <div className={classes.body}>
        <div className={classNames({
          [classes.body__content]: true,
          [classes['body__content--placeholder']]: isPlaceholder,
        })}>
          <NextImage
            alt={title}
            fill={true}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 20vw"
            src={image}
          />
          {isLocked &&
            <div className={classes.tags}>
              <FontAwesomeIcon icon={faLock} />
            </div>
          }
        </div>
        <Overlay
          item={item}
          imageCut={imageCut}
        />
      </div>
    </div>
  )
}

const Overlay = (props: OverlayProps) => {
  const { item, imageCut } = props
  const { url: secondaryImage } = useImage({ images: item?.images, cut: imageCut, scale: '75', index: 1 })

  return (
    <div className={classNames({ [classes.overlay]: true })}>
      <NextImage
        alt={'hovered-image'}
        fill={true}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 20vw"
        src={secondaryImage}
      />
    </div>
  )
}